import { render, staticRenderFns } from "./News_Album.vue?vue&type=template&id=9adddd32&"
import script from "./News_Album.vue?vue&type=script&lang=js&"
export * from "./News_Album.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports